// Centralized feature flags for myConversations
export const FEATURE_FLAGS = {
  // Toggle messaging feature (default: enabled)
  MESSAGING_ENABLED: true,
  // Toggle emoji reactions on messages (default: disabled)
  EMOJI_REACTIONS_ENABLED: false,
  // Toggle pin message feature (default: disabled)
  PIN_MESSAGE_ENABLED: false,
  // Toggle user availability status (available/away/dnd/offline) (default: disabled)
  USER_STATUS_ENABLED: false,
  // Toggle attachments/files tab in channel info (default: disabled)
  ATTACHMENTS_ENABLED: true,
};
